import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromRoot from '@shared/store';

import * as fromCounterparty from './counterparty.reducer';

export const counterpartyFeatureKey = 'counterparty';

export interface CounterpartyState {
  [fromCounterparty.counterpartyListFeatureKey]: fromCounterparty.CounterpartyState;
}

export interface State extends fromRoot.RootState {
  [counterpartyFeatureKey]: CounterpartyState;
}

export const reducers = (state: CounterpartyState | undefined, action: Action) => {
  return combineReducers({
    [fromCounterparty.counterpartyListFeatureKey]: fromCounterparty.reducer,
  })(state, action);
};

export const selectCounterpartyState = createFeatureSelector<CounterpartyState>(counterpartyFeatureKey);

export const selectCounterpartyListState = createSelector(selectCounterpartyState, (state) => state?.list);

export const selectCounterpartyList = createSelector(selectCounterpartyListState, fromCounterparty.getCounterparty);

export const selectCounterpartyTotalElements = createSelector(selectCounterpartyListState, fromCounterparty.getTotalElements);

export const selectCounterpartyLoading = createSelector(selectCounterpartyListState, fromCounterparty.getLoading);
